<template>
  <div class="wrap-nav">
    <Nav />

    <div class="wrap-content">
      <Rules v-if="navAwards[1].active" />
      <Judges v-if="navAwards[0].active" />
      <Categories v-if="navAwards[2].active" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

const Nav = () => import('./Parts/Nav')
const Rules = () => import('./Rules/Main')
const Judges = () => import('./Judges/Main')
const Categories = () => import('./Categories/Main')

export default {
  components: {
    Nav,
    Rules,
    Judges,
    Categories
  },

  computed: {
    ...mapState({
      navAwards: state => state.nav.navAwards
    })
  },

  created () {
    this.$store.dispatch('awards/getRules')
    this.$store.dispatch('awards/getJudgeCate')
    this.$store.dispatch('awards/getJudgeList', 1)
    this.$store.dispatch('awards/getCateList')
    this.$store.dispatch('awards/getLinks')
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
</style>
